import React from "react";
import PT from "prop-types";
import * as S from "./styled";
import isempty from "lodash/isEmpty";
import Item from "./Item";
import { useTranslation } from "react-i18next";
import { HeartsPreloader } from "_c/preloader";
import { Button } from "_c/button";
import { CLIENT_PROFILE_NS } from "@/i18n/ns";

const ClientProfileFeed = (props) => {
  const empty = isempty(props.feed);
  const { t, ready } = useTranslation(["common", CLIENT_PROFILE_NS], {
    useSuspense: false,
  });
  if (!ready) return <HeartsPreloader centered />;
  return (
    <S.Wrap>
      <S.Head>{t("client_profile:feed.title")}</S.Head>
      {empty && (
        <div>
          <S.Placeholder>
            {props.isOwner
              ? t("client_profile:feed.empty.owner")
              : t("client_profile:feed.empty.guest")}
          </S.Placeholder>
        </div>
      )}
      {!empty && (
        <ul>
          {props.feed.map(({ entity, entity_ref, date }) => {
            return (
              <Item
                t={t}
                openShareModal={props.openShareModal}
                favorites={props.favorites[entity_ref]}
                loadComments={props.loadComments}
                addComment={props.addComment}
                removeComment={props.removeComment}
                clientAvatar={props.clientAvatar}
                clientSex={props.clientSex}
                isOwner={props.isOwner}
                key={entity._id}
                type={entity_ref}
                date={date}
                authUserId={props.authUserId}
                data={entity}
                isAuth={props.isAuth}
                toggleLike={props.toggleLike}
                openPortfolioGallery={props.openPortfolioGallery}
              />
            );
          })}
        </ul>
      )}
      {props.isMore && (
        <div style={{ display: "flex" }}>
          <Button
            disabled={props.loading}
            onClick={() => props.loadMore()}
            small
            centered
          >
            {t("common:load_more")}
          </Button>
        </div>
      )}
    </S.Wrap>
  );
};
ClientProfileFeed.propTypes = {
  isOwner: PT.bool,
  feed: PT.array,
  loading: PT.bool,
  error: PT.any,
  clientAvatar: PT.string,
  clientSex: PT.bool,
  favorites: PT.object,
  isMore: PT.bool,
  isAuth: PT.bool,
  authUserId: PT.string,

  loadMore: PT.func.isRequired,
  toggleLike: PT.func.isRequired,
  loadComments: PT.func.isRequired,
  addComment: PT.func.isRequired,
  removeComment: PT.func.isRequired,
  openPortfolioGallery: PT.func.isRequired,
  openShareModal: PT.func.isRequired,
};

export default ClientProfileFeed;
